import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';


import fondo from '../../assets/img/landingPage/fondo.png';

import features_1 from '../../assets/img/landingPage/orchestrator/orchestrator_01.png'
import features_2 from '../../assets/img/landingPage/orchestrator/orchestrator_02.png'
import features_3 from '../../assets/img/landingPage/orchestrator/orchestrator_03.png'

import icon_1 from '../../assets/img/landingPage/orchestrator/icn_Orchestrator-01.png'
import icon_2 from '../../assets/img/landingPage/orchestrator/icn_Orchestrator-02.png'
import icon_3 from '../../assets/img/landingPage/orchestrator/icn_Orchestrator-03.png'

import logo from '../../assets/img/logos/AVAP_Orchestrator-negativo.svg'
import dividerbg from '../../assets/img/landingPage/hexagono-horizonte.png'




import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'
import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'


const OrchestratorProduct = () => {
    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}>
               
                {/* Hero Section */}
                <section id="heroProduct" className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo AVAP Orchestrator"
                        className="img-fluid logo"
                    />
                    <h1 className="fl-title m-0">Full Control. Zero Code. Maximum Impact</h1>
                    <p className="fl-subtitle">
                    Govern, activate, and optimize your API flows from a secure, intelligent command center

                    </p>
                    <a className="glowBtn-dark fakeHide" href="#"><span className="btnInner">  Start with AVAP Cloud</span></a>
                </section>

                {/* Powerful API Platform */}
                <section className="container text-center pb-5">
                    <div className="row">
                        <div className="col">
                            {/* <p className="fl-subtitle mb-3">
                                Titulo
                            </p> */}
                            {/* <img
                                src="https://placehold.co/1026x423"
                                alt="Platform Placeholder"
                                className="img-fluid mt-4 mb-5"
                            /> */}
                            <p className="fl-subtitle mb-3">
                                Operational Control Over API Flow Execution
                            </p>
                            <p className="fl-text">
                                AVAP Orchestrator gives centralized control over the execution of pre-designed API flows. Built to simplify governance, AVAP Orchestrator separates the logic design (handled in AVAP Flow) from its activation, configuration, and runtime management. With access to a full library of flows, managers can decide when and how each flow is deployed—without writing code. Intelligent Gen-AI support offers insights and optimization recommendations, making orchestration smarter and more aligned with business needs.

                            </p>
                        </div>
                    </div>

                </section>

    
                {/* Features */}
                           <section className="container pb-5">
                    <div className="row">
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_1} alt="icon_1" />
                                <p>Flow Activation and Control</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_2} alt="icon_2" />
                                <p>Library-based Governance</p>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="fl-pill">
                                <img src={icon_3} alt="icon_3" />
                                <p>Gen-AI Insights </p>
                            </div>
                        </div>
                    </div>
                </section> 

                {/* Beyond a Proxy */}
                <section className="container py-5 gradient-d fl-br-20 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 text-center">
                            <img
                                src={features_1}
                                alt="Image of a code repository representing the organization and management of code for version control"
                                className="img-fluid"
                                style={{ height: '400px' }}
                            />
                        </div>
                        <div className="col-md-6 pr-5">

                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Centralized Flow Activation & Deactivation</h3>
                            <p className="fl-text">
                                Securely launch, pause, or schedule execution of flows directly from the orchestration dashboard. All flows come from a pre-approved AVAP library—no need to access the development environment.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Comprehensive API Management */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 pl-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">Runtime Configuration Management</h3>
                            <p className="fl-text">
                              Easily configure variables, triggers, and environments for each flow, adapting them to business requirements or operational constraints. Changes are instant and require no redeployment.
                            </p>
                        </div>

                        <div className="col-md-6 text-center">
                            <img
                                src={features_2}
                                alt="Image of version tracking system in AVAP API Source Control."
                                className="img-fluid"
                                style={{ height: '400px' }}
                            />
                        </div>
                    </div>

                </section>

                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-6 text-center">
                            <img
                                src={features_3}
                                alt="Visual representation of code evolution showing the progression of changes and updates."
                                className="img-fluid"
                                style={{ height: '400px' }}
                            />
                        </div>



                        <div className="col-md-6 pr-5">
                            <span className="fl-label">Key Features</span>
                            <h3 className="fl-title">AI-Powered Execution Insights
                            </h3>
                            <p className="fl-text">
                                AVAP Orchestrator uses Gen-AI to surface optimization opportunities: identify underused flows, flag configuration risks, and suggest performance improvements based on live metrics and historical usage.
                             </p>
                        </div>

                    </div>
                </section>

                <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                    Hands-On Governance Without Hands-on Code
                                </p>
                                <p className="fl-text">
                                    Manage flow behavior without needing to build or modify logic. Ideal for operational control, compliance, and service delivery teams.
                                    <br />
                                    &nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                    Faster Response to Business Needs
                                </p>
                                <p className="fl-text">
                                    Quickly adjust flow settings and behaviors as business priorities shift, without looping in development cycles.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                {/* <img src="https://placehold.co/50x50" alt="" /> */}
                                <p className="fl-subtitle-xs">
                                    Smarter Oversight with AI
                                </p>
                                <p className="fl-text">
                                    Gen-AI recommendations help IT managers anticipate performance issues, scale proactively, and reduce manual oversight.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Getting Started */}
                <div className="bottomWrapper position-relative d-flex justify-content-center">
                    <img src={gradientbottom} alt="" className="gradient gradientBottom" />
                </div>
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default OrchestratorProduct;
